<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">

                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li>
                                  <router-link :title="'ميزانية البرنامج'" :to="{name: 'budgets'}">ميزانية البرنامج</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'إضافة جديد'" :to="{name: 'budgets.create'}">إضافة جديد</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                        <h4>
                                              <i class="flaticon-computer-4"></i>
                                          بيانات ميزانية البرنامج</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">

                              <form @submit.prevent="store()">
                                <div class="row mt-4">
                                    <div class="col-md-4">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">التاريخ المتوقع لإقامة البرنامج</label>
                                            <date-picker v-model="data.form.program_date" :editable="true" :calendar="'hijri'"></date-picker>
                                            <div class="invalid-feedback" :style="getErrors['program_date'] ? 'display: block' : 'display: none;'"  v-if="getErrors['program_date']">
                                                  {{ getErrors['program_date'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                        <div class="col-md-4">
                                             <label for="exampleFormControlInput12">وصف البرنامج</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.description" placeholder="وصف البرنامج">
                                            <div class="invalid-feedback" :style="getErrors['description'] ? 'display: block' : 'display: none;'"  v-if="getErrors['description']">
                                                  {{ getErrors['description'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                                                        <div class="col-md-4">
                                       <label for="exampleFormControlInput12"> المكان</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-location"></i></span>
                                      </div>


                                            <input type="text" class="form-control" v-model="data.form.place" placeholder="المكان">
                                            <div class="invalid-feedback" :style="getErrors['place'] ? 'display: block' : 'display: none;'"  v-if="getErrors['place']">
                                                  {{ getErrors['place'][0] }}
                                            </div>
                                        </div>
                                      </div>
                                      <div :class="user.role == 'admin' ? 'col-md-4' : 'col-md-6'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المراحل الدراسية</label>
                                            <treeselect :options="stages" v-model="data.form.stages" @input="getStageCount" :multiple="true" />

                                            <div class="invalid-feedback" :style="getErrors['stages'] ? 'display: block' : 'display: none;'"  v-if="getErrors['stages']">
                                                  {{ getErrors['stages'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div :class="user.role == 'admin' ? 'col-md-4' : 'col-md-6'" v-if="user.role == 'admin'">
                                        <div class="form-group mb-4">
                                            <label for="exampleFormControlInput12">المسئول</label>
                                            <v-select v-model="teacher" :options="teachers" />
                                            <div class="invalid-feedback" :style="getErrors['teacher_id'] ? 'display: block' : 'display: none;'"  v-if="getErrors['teacher_id']">
                                                  {{ getErrors['teacher_id'][0] }}
                                            </div>
                                        </div>
                                      </div>

                                      <div :class="user.role == 'admin' ? 'col-md-4' : 'col-md-6'">


                                <label for="exampleFormControlInput12">الفترة</label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-clock"></i></span>
                                      </div>

                                            <input type="text" class="form-control" v-model="data.form.period" placeholder="الفترة" required>
                                            <div class="invalid-feedback" :style="getErrors['period'] ? 'display: block' : 'display: none;'"  v-if="getErrors['period']">
                                                  {{ getErrors['period'][0] }}
                                            </div>
                                        </div>
                                      </div>


                                      <div class="col-md-8">
                                        <a href="#" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-plus" @click.prevent="addItem">اضافة بند</a>
                                        <table class="table table-bordered">
                                          <thead>
                                            <tr class="text-center">
                                              <th colspan="4">تكلفة البرنامج التقديرية</th>
                                            </tr>
                                            <tr>
                                              <th>البند</th>
                                              <th>التكلفة التقديرية</th>
                                              <th>الوصف</th>
                                              <th>#</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr v-for="(i, k) in data.form.items" :key="k">
                                              <td style="width: 33%">
                                                <treeselect :options="items" :auto-load-root-options="true" @select="checkItemFound($event, k)" v-model="data.form.items[k].item_id" :multiple="false"/>
                                                 <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_id'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_id']">
                                                      {{ getErrors['items.'+k+'.item_id'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="text" v-model="data.form.items[k].item_cost" @change="clcTotalCost();" class="form-control" >
                                                <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_cost'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_cost']">
                                                      {{ getErrors['items.'+k+'.item_cost'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <input type="text" v-model="data.form.items[k].item_description" class="form-control" >
                                                <div class="invalid-feedback" :style="getErrors['items.'+k+'.item_description'] ? 'display: block' : 'display: none;'"   v-if="getErrors['items.'+k+'.item_description']">
                                                      {{ getErrors['items.'+k+'.item_description'][0] }}
                                                </div>
                                              </td>
                                              <td>
                                                <a href="#" class="btn btn-danger" @click.prevent="deleteItem(data.form.items[k])" v-if="k != 0">X</a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <div class="col-md-4">



                                            <label for="exampleFormControlInput12"> عدد طلاب المرحلة </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                              <input type="text" class="form-control" v-model="data.form.student_stage_no"  placeholder="عدد طلاب المرحلة">
                                              <div class="invalid-feedback" :style="getErrors['student_stage_no'] ? 'display: block' : 'display: none;'"  v-if="getErrors['student_stage_no']">
                                                    {{ getErrors['student_stage_no'][0] }}
                                              </div>
                                          </div>





                                            <label for="exampleFormControlInput12"> عدد الحضور المتوقع </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                              <input type="text" class="form-control" v-model="data.form.attend_no" @change="clcFee();" placeholder="عدد الحضور المتوقع">
                                              <div class="invalid-feedback" :style="getErrors['attend_no'] ? 'display: block' : 'display: none;'"  v-if="getErrors['attend_no']">
                                                    {{ getErrors['attend_no'][0] }}
                                              </div>
                                          </div>





                                    <label for="exampleFormControlInput12"> رسوم الاشتراك </label>
                                  <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>


                                              <input type="text" class="form-control" v-model="data.form.fees" @change="clcFee();" placeholder="رسوم الاشتراك">
                                              <div class="invalid-feedback" :style="getErrors['fees'] ? 'display: block' : 'display: none;'"  v-if="getErrors['fees']">
                                                    {{ getErrors['fees'][0] }}
                                              </div>
                                          </div>



                                              <label for="exampleFormControlInput12"> إجمالى الاشتراك </label>
                                              <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                              <input type="text" class="form-control" v-model="data.form.total_fees" @change="clcTotalExp" placeholder="إجمالى الاشتراك">
                                              <div class="invalid-feedback" :style="getErrors['total_fees'] ? 'display: block' : 'display: none;'"  v-if="getErrors['total_fees']">
                                                    {{ getErrors['total_fees'][0] }}
                                              </div>
                                          </div>


                                              <label for="exampleFormControlInput12"> إجمالى التكلفة التقديرية </label>
                                              <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                              <input type="text" class="form-control" v-model="data.form.total_cost" @change="clcTotalExp" placeholder="إجمالى ">
                                              <div class="invalid-feedback" :style="getErrors['total_cost'] ? 'display: block' : 'display: none;'"  v-if="getErrors['total_cost']">
                                                    {{ getErrors['total_cost'][0] }}
                                              </div>
                                          </div>


                                              <label for="exampleFormControlInput12">العجز المتوقع </label>
                                              <div class="input-group mb-4">

                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-money"></i></span>
                                      </div>
                                              <input type="text" class="form-control" v-model="data.form.expect_cost" placeholder="العجز المتوقع " disabled>
                                              <div class="invalid-feedback" :style="getErrors['expect_cost'] ? 'display: block' : 'display: none;'"  v-if="getErrors['expect_cost']">
                                                    {{ getErrors['expect_cost'][0] }}
                                              </div>

                                        </div>
                                      </div>




                                    </div>

                                    <button type="submit" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'budgets'}">
                                      <span>رجوع</span>
                                    </router-link>
                                </form>

                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      date: '',
      stages: [],
      stage: '',
      teacher: '',
      items: [],
      teachers: [],
      group: '',
      data: {
        checker: false,
        form:{
            program_date: '',
            teacher_id: '',
            stages: [],
            period: '',
            description: '',
            place: '',
            student_stage_no: '',
            attend_no: '',
            fees: '',
            total_fees: '',
            total_cost: '',
            expect_cost: '',
            items: [
              {
                item_id: '',
                item_description: '',
                item_cost: ''
              }
            ]
        },
        roles: {
        },
        options: [],
        isRequested: false,
        errors: {},
        paginated: {}
      }
    };
  },
  created(){

    this.getRequirements();
  },
  methods: {
    resetForm(){
      this.data.form = {
            program_date: '',
            teacher_id: '',
            stages: [],
            period: '',
            description: '',
            place: '',
            student_stage_no: '',
            attend_no: '',
            fees: '',
            total_fees: '',
            total_cost: '',
            expect_cost: '',
            items: [
              {
                item_id: '',
                item_description: '',
                item_cost: ''
              }
            ]
        };
    },

    checkItemFound(val, k){
      for (let index = 0; index < this.data.form.items.length; index++) {
         if(this.data.form.items[index].item_id == val.id && k != index){
          this.sweetAlert('البند مضاف بالفعل', 'warning');
          return;
         }
      }
    },
    clcTotalCost(){
      let total = 0;
      for (let index = 0; index < this.data.form.items.length; index++) {
         total += Number(this.data.form.items[index].item_cost);
      }
      this.data.form.total_cost = total;
      this.clcTotalExp();
    },
    clcTotalExp(){
       var totalCost = this.data.form.total_cost ? this.data.form.total_cost : 0;
      var totalFees = this.data.form.total_fees ? this.data.form.total_fees : 0;
      this.data.form.expect_cost = (Number(totalFees) - Number(totalCost));
    },
     deleteItem(data){
      this.data.form.items.splice(this.data.form.items.indexOf(data), 1);
      this.clcTotalCost();
    },
    addItem(){
      this.data.form.items.push({
          item_id: '',
          item_description: '',
          item_cost: ''
      })
    },
     clcFee(){
      if(this.data.form.fees != '' && this.data.form.attend_no != ''){
        this.data.form.total_fees = (Number(this.data.form.fees) * Number(this.data.form.attend_no));
        this.clcTotalExp();
      }
     },
      store(){
          this.data.isRequested = true;
         this.$baseApi.post('/budgets', this.data.form).then((response)=>{
            if(response.data.code === 200){
                localStorage.setItem('flash_message', response.data.messages[0]);
                router.push('/budgets');
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
            this.data.isRequested = false
          })
      },
      getRequirements(){
        this.getData();
      },
      getData(){
        this.$baseApi.get('/budgets/create').then((response)=>{
            if(response.data.code == 200){
               this.teachers = response.data.data.teachers;
               this.stages = response.data.data.stages;
               this.items = response.data.data.items;
            }else if(response.data.status == 401){
                this.error.auth = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
      getStageCount(val){
        this.data.form.student_stage_no = 0;
        this.$baseApi.get('/budgets/create?count=1', {
                    params: {stages: this.data.form.stages}
                }).then((response)=>{
            if(response.data.code == 200){
              this.data.form.student_stage_no = response.data.data.count;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      selected(node, instanceId){
        this.data.form.location_id = node.id;
      },
      getTree(){
        this.$baseApi.get('/locations?tree=true' ).then((response)=>{
            if(response.data.code == 200){
              this.data.options = response.data.data;
            }else if(response.data.code == 401){
                this.error = response.data.error.error;
            }else{
                alert(response.data.error.error);
            }
        });
      },
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
  watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.form.stage_id = newValue.id;
      this.getStageCount();
    },
    teacher(newValue) {
      this.data.form.teacher_id = newValue.id;
    },
  }
};
</script>
<style>
</style>
